
export const CellStatusEnum = {
    unoccupied: 'unoccupied',
    rest: 'rest',
    occupied: 'occupied'
}
    
// prototype vs class
class CellState {
    constructor(isInteractable, cellStatus) {
        this.isInteractable = isInteractable;
        this.cellStatus = cellStatus;
    }
}

export class CalendarState {
    constructor(levelConfig) {
        this.matSize = { numRows: 5, numCols: 7};

        this.cellGrid = [];

        let flatIdx = 0;

        for (var i = 0; i < this.matSize.numRows; i++) {
            this.cellGrid.push([]);
            for (var j = 0; j < this.matSize.numCols; j++) {
                
                let cellRow = this.cellGrid[i];

                // cellState
                // just loop thru the array...sets are weird..
                const hasFixedRest = levelConfig.restHintIdx2Ds.some(idx2D => idx2D.i == i && idx2D.j == j);
                const hasFixedEvent = levelConfig.eventHintIdx2Ds.some(idx2D => idx2D.i == i && idx2D.j == j);

                const isOutOfMonth = flatIdx < levelConfig.monthInfo.monthStartIdx1D
                  || flatIdx >= (levelConfig.monthInfo.monthStartIdx1D + levelConfig.monthInfo.numDaysInMonth);

                const isFixed = hasFixedRest || hasFixedEvent || isOutOfMonth;
                const cellStatus = hasFixedRest
                  ? CellStatusEnum.rest
                  : hasFixedEvent
                    ? CellStatusEnum.occupied
                    : CellStatusEnum.unoccupied;

                const cellState = new CellState(!isFixed, cellStatus);
                
                cellRow.push(cellState);
                
                flatIdx++;
            }

        }
    }
}